import React, { useEffect } from "react";
import { Box, Typography, Container } from "@mui/material";
import {   Card, CardMedia, CardContent, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import {  Grid,  } from "@mui/material";

import Footer from "./Footer";

const jobs = [
    {
      id: 1,
      title: "UI Developer",
      location: "Location :  Remote , India",
      skill:"Skills :  Experience in React, Angular, or Vue.js",
      route: "/job/ui-developer"
    },
    {
      id: 2,
      title: "Sales and Marketing Executive",
      location: "Location :  Remote , India",
      skill:"Skills :  Experience in sales and marketing with excellent communication skill",
      route: "/job/sales-marketing"
    }
  ];

const Careers = () => {
    const isMobile = useMediaQuery("(max-width: 900px)");
    const navigate = useNavigate();
   // const [selectedJobIndex, setSelectedJobIndex] = useState(1); // Default selection
  //  const selectedJob = jobs[selectedJobIndex];
  



    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);




          const caseStudies = [
            {
              title: " Working at Tech Informatic Solutions",
              
              description:
                "Join a community with a shared purpose.",
              image: "/image/career.jpg",
              link: "/careercs1", // updated
            },
            {
              title: "Students & graduates",
              
              description:
                "Explore where life at Tech Informatic Solutions could take you.",
              image: "/image/careercs2.jpg",
              link: "/careercs2", // updated
            },
          ];




  return (
    <Box  sx={{ background: "radial-gradient(circle, #1F6788,#161623)"}}>

      {/* Hero Section */}
      <Box
        sx={{
          height: "100vh",
          backgroundImage: `url('/image/career2.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
        }}
       
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "white",  fontWeight:"bold" , fontSize: { xs: "42px", md: "70px" }}} mb={4}>
         
          Search Jobs
          </Typography>
          <Typography 
                variant="body1" 
                sx={{ 
                  fontSize: { xs: "24px", md: "32px" }, 
                  maxWidth: "100%", 
                  wordBreak: "break-word", 
                //  lineHeight: 2, 
                  color:"white"
                }}
                mb={2}
              >
            Your Career With Tech Informatic Solutions </Typography>
            <Typography 
                variant="body1" 
                sx={{ 
                  fontSize: { xs: "18px", md: "18px" }, 
                  maxWidth: "100%", 
                  wordBreak: "break-word", 
                  lineHeight: 1.5, 
                  color:"white"
                }}
              >
           You can make a positive impact on the world around you.</Typography>
           
        </Box>
      </Box>

      {/* Business Needs Section */}
      <Container sx={{ py: 15 }}>
     
        <Typography variant="h3" sx={{  color: "white", fontSize: { xs: "34px", md: "42px" } }} mb={3}>
        Be a part of <strong>TECH INFORMATIC SOLUTIONS</strong>
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "white", mb: 3 }}>
        Be part of creating positive change and making the world better for our people, our clients, and the communities where we live and work.
        </Typography>
         <Typography variant="h4" sx={{  color: "white" }} fontWeight="bold" mb={3}>
         Work for Tech Informatic Solutions around the world :
                </Typography>
                <Typography variant="body1" sx={{ fontSize: "18px", color: "white", mb: 3 }}>
                The world’s largest enterprises need our scaled, trusted model for delivery to compete in today’s market. We pioneered the shift-left testing, DevOps, and continuous integration concepts, and our development teams across India embrace Tech Informatic Solutions's Agile methodology.</Typography>
                <Typography variant="body1" sx={{ fontSize: "18px", color: "white", mb: 3 }}>
                We seek individuals who are ready to make a difference, take on new challenges, and grow their technical careers. Join our team and become a part of our loyal, innovative and fun culture. </Typography>
               


{/* 2nd section */}


      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          color: "white",
          padding: { xs: "20px 0", sm: "30px", md: "40px 5%" },
          gap: 2,
          width: "90%",
          maxWidth: "1400px",
         // background: "radial-gradient(circle, #1F6788,#161623)",
         backgroundColor:"#B0E0E6",
          margin: "0 auto",
          marginTop: isMobile ? "100px" : "100px",
          boxShadow: `
            0px 12px 25px rgba(0, 0, 0, 0.6),  
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7),
            inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
            inset -10px 0px 20px rgba(255, 255, 255, 0.2)
          `,
        }}
      >
        {/* Top Result Count */}
        <Typography
  variant="h6"
  sx={{
    mb: 2,
    color: "black",
    ml: { xs: 3, md: 0 } // shift left on mobile, normal on desktop
  }}
>
          {jobs.length} Results
        </Typography>

        {/* Job Cards */}
        <Grid container spacing={2}>
          {jobs.map((job, index) => (
            <Grid item xs={12} key={index}>
              <Box
                onClick={() => navigate(job.route)}
                sx={{
                    width: { xs: "80%", md: "100%" }, // narrower width on mobile
                    mx: { xs: "auto", md: 0 }, // center horizontally on mobile
                    p: 2,
                    backgroundColor: "#fff",
                    borderLeft: "4px solid transparent",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: 1,
                    borderRadius: 2,
                    "&:hover": {
                      background: "radial-gradient(circle, #1F6788,#161623)",
                      borderLeft: "4px solid #0056b3",
                      boxShadow: 3,
                      "& h6,& h5, & p": {
                        color: "white",
                      },
                  },
                }}
              >
                 <Typography
    variant="h5"
    className="job-title"
    sx={{ fontWeight: 600, color: "black" }}
    mb={1}
  >
    {job.title}
  </Typography>
  <Typography variant="body1" color="text.primary" mb={0.5}>
    {job.skill}
  </Typography>
               
                <Typography variant="body1" color="text.primary">
                  {job.location}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
    





        </Container>
       








{/* 3rd section */}
<Box sx={{  backgroundColor:"#C4D8E2", width: "100%", padding: "200px 0",  marginTop:isMobile ? "100px": "80px", }} >
<Box sx={{ px: { xs: 2, md: 10 }, py: 8 }} >
      {/* Title Section */}
      <Typography variant="h3" color="black" textAlign="center" fontWeight="bold" gutterBottom  mb={4} mt={-20}>
      Good company, Good life ,  Work-life balance
      </Typography>
      <Typography variant="body1" textAlign="center"  sx={{ fontSize: "18px", color: "black", mb: 8 }}>
      This implies a desire for a workplace that values employees' well-being, offers a positive work environment, and supports their personal live.
  </Typography>
     

      <Grid container spacing={4} >
  {caseStudies.map((item, index) => (
    <Grid item xs={12} md={6} key={index} sx={{ display: "flex" }}>
      <Card
        elevation={0}
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          background: "radial-gradient(circle, #1F6788,#161623)",
          color: "white",
          border: "1px solid #eee",
          height: "100%",
          width: "100%",
          minHeight: 500, // ✅ Equal height
          boxShadow: `
            0px 12px 25px rgba(0, 0, 0, 0.6),  
            inset 0px 10px 20px rgba(255, 255, 255, 0.15),
            inset 0px -10px 30px rgba(0, 0, 0, 0.7),
            inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
            inset -10px 0px 20px rgba(255, 255, 255, 0.2)
          `,
        }}
      >
        <CardMedia
          component="img"
          height="350"
          image={item.image}
          alt={item.title}
          sx={{
            objectFit: "cover",       // Fill the box (left-right full)
            objectPosition: "top",    // Align to top (so top isn’t cut off)
          }}
        />

        <CardContent
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              variant="caption"
              sx={{ color: "#1976d2", fontWeight: "bold" }}
            >
              {item.company}
            </Typography>

            <Typography
              variant="h6"
              color="white"
              fontWeight="bold"
              mt={1}
            >
              {item.title}
            </Typography>

            <Typography
              variant="body2"
              mt={1}
              color="white"
              sx={{ flexGrow: 1 }}
            >
              {item.description}
            </Typography>
          </Box>

          <Link
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{ mt: 2, fontWeight: "bold", color: "#90caf9" }}
          >
            Read the case study ↗
          </Link>
        </CardContent>
      </Card>
    </Grid>
  ))}
</Grid>

    </Box>



    <Box sx={{backgroundColor:"white"}} >

    <Box
  sx={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center", // horizontal center
    justifyContent: "center", // vertical center
    textAlign: "center",      // center text
    px: 2,                    // padding for small screens
  }}
  mt={8}
>
  <Typography
    variant="h3"
    sx={{ color: "black", fontWeight:"bold" , fontSize: { xs: "34px", md: "52px" } ,marginTop:"100px"}}
    mb={4}
  >
   Become your next best self
  </Typography>

  <Typography variant="body1" sx={{ fontSize: "18px", color: "black", mb: 3 }}>
  We value continuous learning and curiosity because there’s always more to know, from new technologies to skills that you’ll need as your career advances.
  </Typography>

  
</Box>

{/* banner Section */}
<Box
        sx={{
          height: "90vh",
          backgroundImage: `url('/image/careerscs1.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
          mt:"50px"
         
        }}
      >
        <Box maxWidth="800px"  p={4} borderRadius={2}>
          <Typography variant="h3" sx={{ color: "white",  fontWeight:"bold" , fontSize: { xs: "40px", md: "52px" }}} mb={4}>
         
          Empowering Our Colleagues’ Voices
          </Typography>
      
            <Typography 
                variant="body1" 
                sx={{ 
                  fontSize: { xs: "18px", md: "18px" }, 
                  maxWidth: "100%", 
                  wordBreak: "break-word", 
                  lineHeight: 1.5, 
                  color:"white"
                }}
              >
           There are exciting things happening at Tech Informatic Solutions all the time, and our colleagues are always front and center. We always welcome feedback and have company-wide tools in place so everyone is regularly updated on the business and feel close to our success. Our innovative workforce is full of amazing ideas and our transparent culture ensures each person is valued for their contribution. 
           </Typography>
           
        </Box>
      </Box>
      </Box>







{/* last Section  */}
<Box sx={{backgroundColor:"#B0E0E6"}}>
<Box
  sx={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: "center",
    justifyContent: "center",
    width: "70%",
    padding: isMobile ? "30px 20px" : "50px 50px",
    gap: "50px", // Reduce gap to prevent excessive spacing
    boxSizing: "border-box",
    marginLeft: isMobile ? "60px" : "3in",
    marginRight: isMobile ? "60px" : "3in",
    minHeight: isMobile ? "auto" : "100vh", // Use minHeight instead of fixed height
    paddingTop: isMobile ? "80px" : "0px", // Reduce paddingTop to prevent overlap
    marginBottom: isMobile ? "-50px" : "-200px", // Increase space to avoid overlap
   // background: "linear-gradient(to right, #E0F7FA, #B2EBF2, #80DEEA)",
   backgroundColor:"#B0E0E6",
  }}
>
  {/* Left Content */}
  <Box
    sx={{
      flex: 1,
      textAlign: isMobile ? "center" : "left",
      margin: "0px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    }}
  >
    <Typography
      variant="h3"
      sx={{
        fontSize: isMobile ? "50px" : "60px", // Reduce heading size for mobile
      }}
    >
     Join Our Award-Winning Team and Make a Difference
    </Typography>

    <Typography variant="body1" sx={{ marginTop: 2, fontSize: "18px", color: "#555" }}>
    Our teams around the world are committed to creating a unified, inclusive culture that supports and celebrates one another. We offer many company-sponsored ways to give back on both a global and local level, allowing for each colleague to feel their own contribution is making an impact. With many ways to connect, our colleagues are not bound by office walls and enjoy a variety of perspectives through employee resource groups.Tech Informatic Solutions is proud to offer colleagues opportunities to directly shape our culture and contribute to our employee engagement.  </Typography>

    
  </Box>

  {/* Right Image */}
  <Box
    sx={{
      flex: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0px",
      minHeight: "auto", // Prevents height issues
      marginTop: isMobile ? "50px" : "0px", // Reduced for better alignment
    }}
  >
    <img
      src="/image/careerscs2.jpg"
      alt="About Us"
      style={{
        width: isMobile ? "90%" : "100%",
        maxHeight: "100%",
        objectFit: "cover",
        borderRadius: "10px",
        boxShadow: `
          0px 12px 25px rgba(0, 0, 0, 0.6),  
          inset 0px 10px 20px rgba(255, 255, 255, 0.15),
          inset 0px -10px 30px rgba(0, 0, 0, 0.7),
          inset 10px 0px 20px rgba(0, 0, 0, 0.5), 
          inset -10px 0px 20px rgba(255, 255, 255, 0.2)
        `,
      }}
    />
  </Box>
</Box>
</Box>


    </Box>








   
        <Footer/>
    </Box>


  );
};

export default Careers;